import React, { Component } from "react";
import {Form, Control, Errors, Fieldset} from "react-redux-form";
import NotificationStatus from "../forms/notification_status";
import {required} from "../field_validations";
import EditStatus from "../forms/edit_status";
import moment from "moment/moment";
import _ from 'lodash';
import {toInt} from "../parsers";

export default class LegalEditForm extends Component {
	render(){
		let { project, revision, modalities, match } = this.props;
		let { owner, instance } = project;
		let modality = _.find(modalities.list, {slug: match.params.modality});
		//console.log('modality===>', modality);
		//let agency = !_.isEmpty(conclusion.data) ? conclusion.data.agency:undefined;
		//let owner = agency ? agency.owner:undefined;
		return(
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="revision" onSubmit={(values) => this._handleSubmit(values)}>
						{!_.isEmpty(revision.phase_group) ?
							<h3 className="title is-3" dangerouslySetInnerHTML={{__html: `Revisión - ${revision.phase_group.name}`}}></h3>:''}
						<h5 className="title is-5">{modality ? modality.name:''}</h5>
						<h1 className="title is-6">DATOS DEL TITULAR</h1>
						{owner && !_.isEmpty(owner.data) ?
							<table className="is-fullwidth table project-goal-table no-margin">
								<tbody>
								<tr>
									<td>
										<span className="help is-dark">Titular</span>
										<strong>{owner.data ? `${owner.data.title} ${owner.data.name} ${owner.data.last_name} ${owner.data.slast_name}`:'---'}</strong>
									</td>
									<td>
										<span className="help is-dark">RFC</span>
										<strong>{owner.data.rfc}</strong>
									</td>
									<td>
										<span className="help is-dark">CURP</span>
										<strong>{owner.data.curp}</strong>
									</td>
								</tr>
								</tbody>
								<Fieldset model=".owner.body" component="tbody">
									{_.map(owner.documents_items, (item, d) => {
										let document =owner.data[item.slug] && !_.isObject(owner.data[item.slug]) ? owner.data[item.slug]:undefined;
										return (
											<tr key={d}>
												<td colSpan={3}>
													<div className="field is-grouped is-grouped-multiline">
														<div className="control" key={d}>
															<a target="_blank" className="button is-info" href={document} disabled={document ? false:true}>
																<span className="icon"><i className="fa fa-link" /></span>
																<span>{item.name}</span>
															</a>
														</div>
													</div>
													<div className="field has-addons">
														<div className="control">
															<div className="select">
																<Control model={`[${item.id}].status`} id={`[${item.id}].status`} defaultValue={revision.owner.body && revision.owner.body[item.id] && revision.owner.body[item.id].status ? revision.owner.body[item.id].status : 'success'} component={ NotificationStatus } changeAction={(model,value) => this._changeStatus(model,value, {field:item.slug, model:`revision.owner.body[${item.id}].field`})} errors={{required}} validateOn="change"/>
															</div>
															<Errors model=".owner.body.status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
														</div>
														<div className="control is-expanded">
															<Control.text model={`[${item.id}].comment`} id={`[${item.id}].comment`} className="input" placeholder="Comentario"/>
														</div>
														<div className="control">
															<div className="select">
																<Control model={`[${item.id}].allow_edit`} id={`[${item.id}].allow_edit`} defaultValue={revision.owner.body && !_.isEmpty(revision.owner.body[item.id]) && !_.isEmpty(revision.owner.body[item.id].allow_edit) ? revision.owner.body[item.id].allow_edit : 'false'} component={EditStatus} />
															</div>
														</div>
													</div>
												</td>
											</tr>
										)
									})}
								</Fieldset>
							</table>
							: <p className="has-text-primary"><span className="icon has-text-danger"><i className="fa fa-lg fa-exclamation-triangle" /></span> Sin información <br /><br /></p> }

						<h1 className="title is-6">DATOS DE LA INSTANCIA</h1>
						{instance && !_.isEmpty(instance.data) ?
							<table className="is-fullwidth table project-goal-table no-margin">
							<tbody>
							<tr>
								<td colSpan={2}>
									<span className="help is-dark">Nombre de la instancia</span>
									<strong>{instance.data.name}</strong>
								</td>
								<td>
									<div className="columns">
										<div className="column is-1">
											<i className="fa fa-calendar" />
										</div>
										<div className="column">
											<span className="help is-dark">Fecha de creación</span>
											<strong>{_.capitalize(moment(instance.data.creation_date).format('MMMM YYYY'))}</strong>
										</div>
									</div>
								</td>
							</tr>
							<tr>
								<td colSpan={2}>
									<span className="help is-dark">Naturaleza jurídica</span>
									<strong>{instance.data.legal_nature}</strong>
								</td>
								<td>
									<div className="columns">
										<div className="column is-1">
											<i className="fa fa-calendar" />
										</div>
										<div className="column">
											<span className="help is-dark">Periodo de Gestión</span>
											<strong>{_.capitalize(moment(instance.data.management_period_start).format('MMMM YYYY'))} a {_.capitalize(moment(instance.data.management_period_end).format('MMMM YYYY'))}</strong>
										</div>
									</div>
								</td>
							</tr>
							<tr>
								<td>
									<span className="help is-dark">Dirección</span>
									<strong>{instance.data.street}</strong>
								</td>
								<td>
									<span className="help is-dark">Número</span>
									<strong>{instance.data.num_ext}</strong>
								</td>
								<td>
									<span className="help is-dark">Interior</span>
									<strong>{instance.data.num_int ? instance.data.num_int:'---'}</strong>
								</td>
							</tr>
							<tr>
								<td>
									<span className="help is-dark">Colonia</span>
									<strong>{instance.data.colony}</strong>
								</td>
								<td>
									<span className="help is-dark">Código postal</span>
									<strong>{instance.data.cp}</strong>
								</td>
								<td>
									<span className="help is-dark">Tipo de vialidad</span>
									<strong>{instance.data.road_type ? instance.data.road_type:'---'}</strong>
								</td>
							</tr>
							<tr>
								<td>
									<span className="help is-dark">Estado</span>
									<strong>{this._stateName()}</strong>
								</td>
								<td colSpan={2}>
									<span className="help is-dark">Municipio</span>
									<strong>{this._munName()}</strong>
								</td>
							</tr>
							<tr>
								<td>
									<span className="help is-dark">Teléfono principal </span>
									<strong>{instance.data.telephone}</strong>
								</td>
								<td colSpan={2}>
									<span className="help is-dark">Teléfono alterno</span>
									<strong>{instance.data.telephone_2 ? instance.data.telephone_2:'---'}</strong>
								</td>
							</tr>
							<tr>
								<td>
									<span className="help is-dark">Email principal </span>
									<strong>{instance.data.email}</strong>
								</td>
								<td colSpan={2}>
									<span className="help is-dark">Email secundario</span>
									<strong>{instance.data.email_2 ? instance.data.email_2:'---'}</strong>
								</td>
							</tr>
							{instance && instance.data.type ?
								<tr>
									<td colSpan={3}>
										<span className="help is-dark">Tipo de Instancia</span>
										<strong>{(instance.data.type==='decentralized' ? 'Descentralizada':(instance.data.type==='centralized' ? 'Centralizada':'Delegación'))}</strong>
									</td>
								</tr>
								: <tr><td colSpan={3}></td></tr>}
							</tbody>
							<Fieldset model=".instance.body" component="tbody">
								{_.map(_.filter(instance.documents_items, (o) => {return o.agency_type === null && (o.modality_id === null || o.modality_id === (modality ? modality.id:undefined))}),(item, d) => {
									let document =instance.data[item.slug] && !_.isObject(instance.data[item.slug]) ? instance.data[item.slug]:undefined;
									return (
										<tr key={d}>
											<td colSpan={3}>
												<div className="field">
													<div className="control">
														<a target="_blank" className="button is-info" href={document} disabled={document ? false:true}>
															<span className="icon"><i className="fa fa-link" /></span>
															<span>{item.name}</span>
														</a>
													</div>
												</div>
												<div className="field has-addons">
													<div className="control">
														<div className="select">
															<Control model={`[${item.id}].status`} id={`[${item.id}].status`} defaultValue={revision.instance.body && revision.instance.body[item.id] ? revision.instance.body[item.id].status : 'success'} changeAction={(model,value) => this._changeStatus(model,value, {field: item.slug, model:`revision.instance.body[${item.id}].field`})} component={ NotificationStatus } errors={{required}} validateOn="change"/>
														</div>
														<Errors model={`[${item.id}].status`} show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
													</div>
													<div className="control is-expanded">
														<Control.text model={`[${item.id}].comment`} id={`[${item.id}].comment`} className="input" placeholder="Comentario"/>
													</div>
													<div className="control">
														<div className="select">
															<Control model={`[${item.id}].allow_edit`} id={`[${item.id}].allow_edit`} component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[item.id]) && !_.isEmpty(revision.instance.body[item.id].allow_edit) ? revision.instance.body[item.id].allow_edit:'false'}/>
														</div>
													</div>
												</div>
											</td>
										</tr>
									)
								})}
								{modality && modality.id === 2 && instance.data.type ?
									<tr>
										<td colSpan={3}>
											<strong>DOCUMENTACIÓN ADICIONAL</strong>
										</td>
									</tr>:null}
								{modality && modality.id === 2 && instance.data.type?
									_.map(_.filter(instance.documents_items, (o) => {return o.agency_type === instance.data.type && o.modality_id === (modality ? modality.id:undefined)}),(item, d) => {
										let document =instance.data[item.slug] && !_.isObject(instance.data[item.slug]) ? instance.data[item.slug]:undefined;
										return (
											<tr key={d}>
												<td colSpan={3}>
													<div className="field">
														<div className="control">
															<a target="_blank" className="button is-info" href={document} disabled={document ? false:true}>
																<span className="icon"><i className="fa fa-link" /></span>
																<span>{item.name}</span>
															</a>
														</div>
													</div>
													<div className="field has-addons">
														<div className="control">
															<div className="select">
																<Control model={`[${item.id}].status`} id={`[${item.id}].status`} defaultValue={revision.instance.body && revision.instance.body[item.id] ? revision.instance.body[item.id].status : 'success'} changeAction={(model,value) => this._changeStatus(model,value, {field: item.slug, model:`revision.instance.body[${item.id}].field`})} component={ NotificationStatus } errors={{required}} validateOn="change"/>
															</div>
															<Errors model={`[${item.id}].status`} show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
														</div>
														<div className="control is-expanded">
															<Control.text model={`[${item.id}].comment`} id={`[${item.id}].comment`} className="input" placeholder="Comentario"/>
														</div>
														<div className="control">
															<div className="select">
																<Control model={`[${item.id}].allow_edit`} id={`[${item.id}].allow_edit`} component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[item.id]) && !_.isEmpty(revision.instance.body[item.id].allow_edit) ? revision.instance.body[item.id].allow_edit:'false'}/>
															</div>
														</div>
													</div>
												</td>
											</tr>
										)
									})
									:null}
							</Fieldset>
						</table>
							: <p className="has-text-primary"><span className="icon has-text-danger"><i className="fa fa-lg fa-exclamation-triangle" /></span> Sin información <br /><br /></p> }

						{!_.isEmpty(revision.notifications_types) ?
							<h1 className="title is-6">NOTIFICACIÓN</h1> :''}

						{!_.isEmpty(revision.notifications_types) ?
							<table className="is-fullwidth table project-goal-table no-margin">
								<tbody>
								<tr>
									<td>
										<div className="field">
											<div className="control">
												<label htmlFor="" className="label">Tipo de notificación</label>
												<div className="select">
													<Control.select model=".instance.notification_type_id" id="status" parser={ toInt } className="select" validateOn="change">
														<option value="" defaultValue>--- Tipo ---</option>
														{_.map(revision.notifications_types, (opc, k) => {
															return <option value={opc.id} key={k}>{opc.name}</option>
														})}
													</Control.select>
												</div>
												{/*<Errors model=".conclusion.notification_type_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El tipo de notificación es obligatorio'}} />*/}
											</div>
										</div>
									</td>
								</tr>
								</tbody>
							</table>:''}

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-danger" onClick={() => this.props.history.goBack()}>
									Regresar
								</button>
							</div>

							<div className="control">
								<Control.button model="revision" className="button is-success" >Guardar Comentarios</Control.button>
							</div>
						</div>
					</Form>
				</div>
			</div>
		);
	}

	componentWillMount() {
		let { project } = this.props;
		if(!_.isEmpty(project.instance.data)){
			this.props.fetchMunicipalities(project.instance.data.state_id);
		}
	}

	_handleSubmit(values){
		let { modality, state, municipality } = this.props.match.params;
		this.props.saveLegalRevision(modality, state, municipality, values);
		//console.log('values==>', values);
	}

	_renderExtraDocs() {
		let {project, match, change, revision} = this.props;

		if(project.instance.data && project.instance.data.type === 'decentralized') {
			return (<tr><td colSpan={3}><DecentralizedDocs project={{...project}} revision={revision} change={change}/></td></tr>)
		}else if(project.instance.data && project.instance.data.type === 'centralized') {
			return (<tr><td colSpan={3}><CentralizadDocs project={{...project}} revision={revision} state={match.params.state} change={change}/></td></tr>)
		}else if(project.instance.data && project.instance.data.type === 'delegacy') {
			return (<tr><td colSpan={3}><DelegacyDocs project={{...project}} revision={revision} change={change}/></td></tr>)
		}else if(project.instance.data){
			return (<AgencyDocs project={{...project}} revision={revision} change={change}/>)
		}
	}

	_stateName() {
		let { entities, project } = this.props;
		let state = _.find(entities.list, {id: project.instance.data.state_id});
		return state ? state.name : '---'
	}

	_munName() {
		let { municipalities, project } = this.props;
		let mun = _.find(municipalities.list, {id: project.instance.data.municipality_id});
		return mun ? mun.name : '---'
	}

	_changeStatus(model, values, field) {
		this.props.change(model, values);
		this.props.change(field.model, field.field);
	}
}

class AgencyDocs extends Component{
	render(){
		let {instance} = this.props.project;
		let {revision} = this.props;
		return(
			<tr>
				<td colSpan={3}>
					<div className="field">
						<div className="control">
							<a target="_blank" className="button is-info" href={instance.data.agency_regulation} disabled={instance.data.agency_regulation ? false:true}>
								<span className="icon"><i className="fa fa-link" /></span>
								<span>Reglamento interno</span>
							</a>
						</div>
					</div>
					<div className="field has-addons">
						<div className="control">
							<div className="select">
								<Control model="[5].status" component={ NotificationStatus } defaultValue={revision.instance.body && revision.instance.body[5] ? revision.instance.body[5].status : 'success'} changeAction={(model,value) => this._changeStatus(model,value, {field:'agency_regulation', model:'revision.instance.body[5].field'})} errors={{required}} validateOn="change"/>
							</div>
							<Errors model="[5].status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
						</div>
						<div className="control is-expanded">
							<Control.text model="[5].comment" className="input" placeholder="Comentario"/>
						</div>
						<div className="control">
							<div className="select">
								<Control model="[5].allow_edit" id="official_id" component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[5]) && !_.isEmpty(revision.instance.body[5].allow_edit) ? revision.instance.body[5].allow_edit:'false'}/>
							</div>
						</div>
					</div>
				</td>
			</tr>
		);
	}

	_changeStatus(model, values, field) {
		this.props.change(model, values);
		this.props.change(field.model, field.field);
	}
}

class DecentralizedDocs extends Component{
	render(){
		let {instance} = this.props.project;
		let {revision} = this.props;
		return(
			<table className="is-fullwidth table project-goal-table no-margin">
				<tbody>
					<tr>
						<td colSpan={3}>
							<strong>DOCUMENTACIÓN ADICIONAL</strong>
						</td>
					</tr>
					<tr>
						<td colSpan={3}>
							<div className="field">
								<div className="control">
									<a target="_blank" className="button is-info" href={instance.data.decentralized_agency_regulation} disabled={!instance.data.decentralized_agency_regulation}>
										<span className="icon"><i className="fa fa-link" /></span>
										<span>Reglamento interno</span>
									</a>
								</div>
							</div>
							<div className="field has-addons">
								<div className="control">
									<div className="select">
										<Control model="[5].status" defaultValue={revision.instance.body && revision.instance.body[5] ? revision.instance.body[5].status : 'success'} component={ NotificationStatus } changeAction={(model,value) => this._changeStatus(model,value, {field:'decentralized_agency_regulation', model:'revision.instance.body[5].field'})} errors={{required}} validateOn="change"/>
									</div>
									<Errors model="[5].status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
								</div>
								<div className="control is-expanded">
									<Control.text model="[5].comment" className="input" placeholder="Comentario"/>
								</div>
								<div className="control">
									<div className="select">
										<Control model="[5].allow_edit" id="official_id" component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[5]) && !_.isEmpty(revision.instance.body[5].allow_edit) ? revision.instance.body[5].allow_edit:'false'}/>
									</div>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		);
	}

	_changeStatus(model, values, field) {
		this.props.change(model, values);
		this.props.change(field.model, field.field);
	}
}

class CentralizadDocs extends Component{
	render(){
		let {project, state, revision } = this.props;
		let {instance} = project;
		return(
			<table className="is-fullwidth table project-goal-table no-margin">
				<tbody>
					<tr>
						<td colSpan={3}>
							<strong>DOCUMENTACIÓN ADICIONAL</strong>
						</td>
					</tr>
					<tr>
						<td colSpan={3}>
							<div className="field">
								<div className="control">
									<a target="_blank" className="button is-info" href={instance.data.centralized_majority_votes_constancy} disabled={instance.data.centralized_majority_votes_constancy ? false:true}>
										<span className="icon"><i className="fa fa-link" /></span>
										<span>Constancia de mayoría de votos</span>
									</a>
								</div>
							</div>
							<div className="field has-addons">
								<div className="control">
									<div className="select">
										<Control model="[5].status" defaultValue={revision.instance.body && revision.instance.body[5] ? revision.instance.body[5].status : 'success'} component={ NotificationStatus } changeAction={(model,value) => this._changeStatus(model,value, {field:'centralized_majority_votes_constancy', model:'revision.instance.body[5].field'})} errors={{required}} validateOn="change"/>
									</div>
									<Errors model="[5].status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
								</div>
								<div className="control is-expanded">
									<Control.text model="[5].comment" className="input" placeholder="Comentario"/>
								</div>
								<div className="control">
									<div className="select">
										<Control model="[5].allow_edit" id="official_id" component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[5]) && !_.isEmpty(revision.instance.body[5].allow_edit) ? revision.instance.body[5].allow_edit:'false'}/>
									</div>
								</div>
							</div>
						</td>
					</tr>
					<tr>
						<td colSpan={3}>
							<div className="field">
								<div className="control">
									<a target="_blank" className="button is-info" href={instance.data.centralized_identification_presidency} disabled={instance.data.centralized_identification_presidency ? false:true}>
										<span className="icon"><i className="fa fa-link" /></span>
										<span>Identificación oficial del Presidente Municipal</span>
									</a>
								</div>
							</div>
							<div className="field has-addons">
								<div className="control">
									<div className="select">
										<Control model="[6].status" defaultValue={revision.instance.body && revision.instance.body[6] ? revision.instance.body[6].status : 'success'} component={ NotificationStatus } changeAction={(model,value) => this._changeStatus(model,value, {field:'centralized_identification_presidency', model:'revision.instance.body[6].field'})} errors={{required}} validateOn="change"/>
									</div>
									<Errors model="[6].status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
								</div>
								<div className="control is-expanded">
									<Control.text model="[6].comment" className="input" placeholder="Comentario"/>
								</div>
								<div className="control">
									<div className="select">
										<Control model="[6].allow_edit" id="official_id" component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[6]) && !_.isEmpty(revision.instance.body[6].allow_edit) ? revision.instance.body[6].allow_edit:'false'}/>
									</div>
								</div>
							</div>
						</td>
					</tr>
					<tr>
						<td colSpan={3}>
							<div className="field">
								<div className="control">
									<a target="_blank" className="button is-info" href={instance.data.centralized_designation_municipality} disabled={instance.data.centralized_designation_municipality ? false:true}>
										<span className="icon"><i className="fa fa-link" /></span>
										<span>Nombramiento del titular</span>
									</a>
								</div>
							</div>
							<div className="field has-addons">
								<div className="control">
									<div className="select">
										<Control model="[7].status" defaultValue={revision.instance.body && revision.instance.body[7] ? revision.instance.body[7].status : 'success'} component={ NotificationStatus } changeAction={(model,value) => this._changeStatus(model,value, {field:'centralized_designation_municipality', model:'revision.instance.body[7].field'})} errors={{required}} validateOn="change"/>
									</div>
									<Errors model="[7].status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
								</div>
								<div className="control is-expanded">
									<Control.text model="[7].comment" className="input" placeholder="Comentario"/>
								</div>
								<div className="control">
									<div className="select">
										<Control model="[7].allow_edit" id="official_id" component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[7]) && !_.isEmpty(revision.instance.body[7].allow_edit) ? revision.instance.body[7].allow_edit:'false'}/>
									</div>
								</div>
							</div>
						</td>
					</tr>
					<tr>
						<td colSpan={3}>
							<div className="field">
								<div className="control">
									<a target="_blank" className="button is-info" href={instance.data.centralized_identification_secretary} disabled={instance.data.centralized_identification_secretary ? false:true}>
										<span className="icon"><i className="fa fa-link" /></span>
										<span>Identificación oficial del titular de la Secretaría del Ayuntamiento</span>
									</a>
								</div>
							</div>
							<div className="field has-addons">
								<div className="control">
									<div className="select">
										<Control model="[8].status" defaultValue={revision.instance.body && revision.instance.body[8] ? revision.instance.body[8].status : 'success'} component={ NotificationStatus } changeAction={(model,value) => this._changeStatus(model,value, {field:'centralized_identification_secretary', model:'revision.instance.body[8].field'})} errors={{required}} validateOn="change"/>
									</div>
									<Errors model="[8].status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
								</div>
								<div className="control is-expanded">
									<Control.text model="[8].comment" className="input" placeholder="Comentario"/>
								</div>
								<div className="control">
									<div className="select">
										<Control model="[8].allow_edit" id="official_id" component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[8]) && !_.isEmpty(revision.instance.body[8].allow_edit) ? revision.instance.body[8].allow_edit:'false'}/>
									</div>
								</div>
							</div>
						</td>
					</tr>
					{(state === 'JAL' || state === 'GRO' || state === 'NAY' || state === 'SLP' || state === 'NLE' || state === 'TAB' || state === 'VER') ?
						<tr>
							<td colSpan={3}>
								<div className="field">
									<div className="control">
										<a target="_blank" className="button is-info" href={instance.data.majority_votes_constancy_syndic} disabled={instance.data.majority_votes_constancy_syndic ? false:true}>
											<span className="icon"><i className="fa fa-link" /></span>
											<span>Constancia mayoría votos síndico</span>
										</a>
									</div>
								</div>
								<div className="field has-addons">
									<div className="control">
										<div className="select">
											<Control model="[9].status" defaultValue={revision.instance.body && revision.instance.body[9] ? revision.instance.body[9].status : 'success'} component={ NotificationStatus } changeAction={(model,value) => this._changeStatus(model,value, {field:'majority_votes_constancy_syndic', model:'revision.instance.body[9].field'})} errors={{required}} validateOn="change"/>
										</div>
										<Errors model="[9].status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
									</div>
									<div className="control is-expanded">
										<Control.text model="[9].comment" className="input" placeholder="Comentario"/>
									</div>
									<div className="control">
										<div className="select">
											<Control model="[9].allow_edit" id="official_id" component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[9]) && !_.isEmpty(revision.instance.body[9].allow_edit) ? revision.instance.body[9].allow_edit:'false'}/>
										</div>
									</div>
								</div>
							</td>
						</tr>: <tr><td colSpan={3}></td></tr>}
					{(state === 'JAL' || state === 'GRO' || state === 'NAY' || state === 'SLP' || state === 'NLE' || state === 'TAB' || state === 'VER') ?
						<tr>
							<td colSpan={3}>
								<div className="field">
									<div className="control">
										<a target="_blank" className="button is-info" href={instance.data.official_identification_syndic} disabled={instance.data.official_identification_syndic ? false:true}>
											<span className="icon"><i className="fa fa-link" /></span>
											<span>Identificación oficial síndico</span>
										</a>
									</div>
								</div>
								<div className="field has-addons">
									<div className="control">
										<div className="select">
											<Control model="[10].status" defaultValue={revision.instance.body && revision.instance.body[10] ? revision.instance.body[10].status : 'success'} component={ NotificationStatus } changeAction={(model,value) => this._changeStatus(model,value, {field:'official_identification_syndic', model:'revision.instance.body[10].field'})} errors={{required}} validateOn="change"/>
										</div>
										<Errors model="[10].status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
									</div>
									<div className="control is-expanded">
										<Control.text model="[10].comment" className="input" placeholder="Comentario"/>
									</div>
									<div className="control">
										<div className="select">
											<Control model="[10].allow_edit" id="official_id" component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[10]) && !_.isEmpty(revision.instance.body[10].allow_edit) ? revision.instance.body[10].allow_edit:'false'}/>
										</div>
									</div>
								</div>
							</td>
						</tr>: null}
				</tbody>
			</table>
		);
	}

	_changeStatus(model, values, field) {
		this.props.change(model, values);
		this.props.change(field.model, field.field);
	}
}

class DelegacyDocs extends Component{
	render(){
		let {instance} = this.props.project;
		let {revision} = this.props;
		return(
			<table className="is-fullwidth table project-goal-table no-margin">
				<tr>
					<td colSpan={3}>
						<strong>DOCUMENTACIÓN ADICIONAL</strong>
					</td>
				</tr>
				<tr>
					<td colSpan={3}>
						<div className="field">
							<div className="control">
								<a target="_blank" className="button is-info" href={instance.data.delegacy_administrative_manual} disabled={instance.data.delegacy_administrative_manual ? false:true}>
									<span className="icon"><i className="fa fa-link" /></span>
									<span>Manual administrativo o estatuto orgánico</span>
								</a>
							</div>
						</div>
						<div className="field has-addons">
							<div className="control">
								<div className="select">
									<Control model="[5].status" defaultValue={revision.instance.body && revision.instance.body[5] ? revision.instance.body[5].status : 'success'} component={ NotificationStatus } changeAction={(model,value) => this._changeStatus(model,value, {field:'delegacy_administrative_manual', model:'revision.instance.body[10].field'})} errors={{required}} validateOn="change"/>
								</div>
								<Errors model="[5].status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
							</div>
							<div className="control is-expanded">
								<Control.text model="[5].comment" className="input" placeholder="Comentario"/>
							</div>
							<div className="control">
								<div className="select">
									<Control model="[5].allow_edit" id="official_id" component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[5]) && !_.isEmpty(revision.instance.body[5].allow_edit) ? revision.instance.body[5].allow_edit:'false'}/>
								</div>
							</div>
						</div>
					</td>
				</tr>
				<tr>
					<td colSpan={3}>
						<div className="field">
							<div className="control">
								<a target="_blank" className="button is-info" href={instance.data.delegacy_majority_votes_constancy} disabled={instance.data.delegacy_majority_votes_constancy ? false:true}>
									<span className="icon"><i className="fa fa-link" /></span>
									<span>Constancia de mayoría de votos</span>
								</a>
							</div>
						</div>
						<div className="field has-addons">
							<div className="control">
								<div className="select">
									<Control model="[6].status" defaultValue={revision.instance.body && revision.instance.body[6] ? revision.instance.body[6].status : 'success'} component={ NotificationStatus } changeAction={(model,value) => this._changeStatus(model,value, {field:'delegacy_majority_votes_constancy', model:'revision.instance.body[6].field'})} errors={{required}} validateOn="change"/>
								</div>
								<Errors model="[6].status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
							</div>
							<div className="control is-expanded">
								<Control.text model="[6].comment" className="input" placeholder="Comentario"/>
							</div>
							<div className="control">
								<div className="select">
									<Control model="[6].allow_edit" id="official_id" component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[6]) && !_.isEmpty(revision.instance.body[6].allow_edit) ? revision.instance.body[6].allow_edit:'false'}/>
								</div>
							</div>
						</div>
					</td>
				</tr>
				<tr>
					<td colSpan={3}>
						<div className="field">
							<div className="control">
								<a target="_blank" className="button is-info" href={instance.data.delegacy_identification_owner} disabled={instance.data.delegacy_identification_owner ? false:true}>
									<span className="icon"><i className="fa fa-link" /></span>
									<span>Identificación del titular de la delegación</span>
								</a>
							</div>
						</div>
						<div className="field has-addons">
							<div className="control">
								<div className="select">
									<Control model="[7].status" defaultValue={revision.instance.body && revision.instance.body[7] ? revision.instance.body[7].status : 'success'} component={ NotificationStatus } changeAction={(model,value) => this._changeStatus(model,value, {field:'delegacy_identification_owner', model:'revision.instance.body[7].field'})} errors={{required}} validateOn="change"/>
								</div>
								<Errors model="[7].status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
							</div>
							<div className="control is-expanded">
								<Control.text model="[7].comment" className="input" placeholder="Comentario"/>
							</div>
							<div className="control">
								<div className="select">
									<Control model="[7].allow_edit" id="official_id" component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[7]) && !_.isEmpty(revision.instance.body[7].allow_edit) ? revision.instance.body[7].allow_edit:'false'}/>
								</div>
							</div>
						</div>
					</td>
				</tr>
				<tr>
					<td colSpan={3}>
						<div className="field">
							<div className="control">
								<a target="_blank" className="button is-info" href={instance.data.delegacy_agreement_subscription} disabled={instance.data.delegacy_agreement_subscription ? false:true}>
									<span className="icon"><i className="fa fa-link" /></span>
									<span>Acuerdo para suscripción de convenios</span>
								</a>
							</div>
						</div>
						<div className="field has-addons">
							<div className="control">
								<div className="select">
									<Control model="[8].status" component={ NotificationStatus } changeAction={(model,value) => this._changeStatus(model,value, {field:'delegacy_agreement_subscription', model:'revision.instance.body[8].field'})} errors={{required}} validateOn="change"/>
								</div>
								<Errors model="[8].status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
							</div>
							<div className="control is-expanded">
								<Control.text model="[8].comment" className="input" placeholder="Comentario"/>
							</div>
							<div className="control">
								<div className="select">
									<Control model="[8].allow_edit" id="official_id" component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[8]) && !_.isEmpty(revision.instance.body[8].allow_edit) ? revision.instance.body[8].allow_edit:'false'}/>
								</div>
							</div>
						</div>
					</td>
				</tr>
				<tr>
					<td colSpan={3}>
						<div className="field">
							<div className="control">
								<a target="_blank" className="button is-info" href={instance.data.delegacy_designation_social} disabled={instance.data.delegacy_designation_social ? false:true}>
									<span className="icon"><i className="fa fa-link" /></span>
									<span>Nombramiento</span>
								</a>
							</div>
						</div>
						<div className="field has-addons">
							<div className="control">
								<div className="select">
									<Control model="[9].status" defaultValue={revision.instance.body && revision.instance.body[9] ? revision.instance.body[9].status : 'success'} component={ NotificationStatus } changeAction={(model,value) => this._changeStatus(model,value, {field:'delegacy_designation_social', model:'revision.instance.body[9].field'})} errors={{required}} validateOn="change"/>
								</div>
								<Errors model="[9].status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
							</div>
							<div className="control is-expanded">
								<Control.text model="[9].comment" className="input" placeholder="Comentario"/>
							</div>
							<div className="control">
								<div className="select">
									<Control model="[9].allow_edit" id="official_id" component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[9]) && !_.isEmpty(revision.instance.body[9].allow_edit) ? revision.instance.body[9].allow_edit:'false'}/>
								</div>
							</div>
						</div>
					</td>
				</tr>
				<tr>
					<td colSpan={3}>
						<div className="field">
							<div className="control">
								<a target="_blank" className="button is-info" href={instance.data.delegacy_identification_social} disabled={instance.data.delegacy_identification_social ? false:true}>
									<span className="icon"><i className="fa fa-link" /></span>
									<span>Identificación oficial del titular de la Dirección General de Desarrollo Social</span>
								</a>
							</div>
						</div>
						<div className="field has-addons">
							<div className="control">
								<div className="select">
									<Control model="[10].status" defaultValue={revision.instance.body && revision.instance.body[10] ? revision.instance.body[10].status : 'success'} component={ NotificationStatus } changeAction={(model,value) => this._changeStatus(model,value, {field:'delegacy_identification_social', model:'revision.instance.body[10].field'})} errors={{required}} validateOn="change"/>
								</div>
								<Errors model="[10].status" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
							</div>
							<div className="control is-expanded">
								<Control.text model="[10].comment" className="input" placeholder="Comentario"/>
							</div>
							<div className="control">
								<div className="select">
									<Control model="[10].allow_edit" id="official_id" component={EditStatus} defaultValue={revision.instance.body && !_.isEmpty(revision.instance.body[10]) && !_.isEmpty(revision.instance.body[10].allow_edit) ? revision.instance.body[10].allow_edit:'false'}/>
								</div>
							</div>
						</div>
					</td>
				</tr>
			</table>
		);
	}

	_changeStatus(model, values, field) {
		this.props.change(model, values);
		this.props.change(field.model, field.field);
	}
}


// WEBPACK FOOTER //
// ./src/elements/revision/legal.jsx